import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  interpreterDashboard: {
    analytics: [],
    appointments: [],
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const interpreterDashboardSlice = createSlice({
  name: 'interpreterDashboard',
  initialState: initialState,
  reducers: {
    setInterpreterDashboardAnalytic: (state, { payload }) => {
      state.interpreterDashboard = payload?.data ?? payload;
    },
    setInterpreterDashboardAnalytics: (state, { payload }) => {
      state.interpreterDashboard.analytics = payload;
    },
    setInterpreterDashboardAppointments: (state, { payload }) => {
        state.interpreterDashboard.appointments = payload?.data;
        state.total = payload?.total;
        state.is_more = payload?.is_more;
        state.last_page = payload?.last_page;
        state.current_page = payload?.current_page;
        state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllInterpreterDashboard: (state, { payload }) => {
        state.loader = payload
    },
    setError: (state, { payload }) => {
        state.error = payload
    },
    setLoader: (state, { payload }) => {
        state.loader = payload
    },
  }
})


export const fetchInterpreterDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
      
      const result = await Api.fetchInterpreterDashboardAnalytics(params)
      if (result.status >= 200 && result.status < 300) {
          dispatch(setInterpreterDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
        dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
    
  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchInterpreterDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

      const result = await Api.fetchInterpreterDashboardAppointments(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setInterpreterDashboardAppointments(result.data.data));
      } else {
        dispatch(setInterpreterDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}




export const { setInterpreterDashboardAnalytics, clearAllInterpreterDashboard, setLoader, setError ,setInterpreterDashboardAppointments} = interpreterDashboardSlice.actions

export default interpreterDashboardSlice.reducer
export const InterpreterDashboardSelector = state => state.interpreterDashboard



